
const routes = [
    {
        path: '/dashboard',
        name: 'dashboard.index',
        component: () => import('@/pages/Dashboard/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/courses',
        name: 'dashboard.courses',
        component: () => import('@/pages/Dashboard/CourseIndex.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/notifications',
        name: 'dashboard.notifications',
        component: () => import('@/pages/Dashboard/NotificationIndex.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/courses/:id/show',
        name: 'dashboard.courses.show',
        component: () => import('@/pages/Dashboard/CourseShow.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/courses/:id/lessons/:lesson_id/show',
        name: 'dashboard.courses.lesson',
        component: () => import('@/pages/Dashboard/CourseContent.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/courses/:id/lessons/:lesson_id/vocabulary',
        name: 'dashboard.courses.vocabulary',
        component: () => import('@/pages/Dashboard/LessonVocabulary.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/courses/my',
        name: 'dashboard.my_courses',
        component: () => import('@/pages/Dashboard/MyCoursesIndex.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/reels',
        name: 'dashboard.reels',
        component: () => import('@/pages/Dashboard/ReelsPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/support',
        name: 'dashboard.support',
        component: () => import('@/pages/Dashboard/SupportIndex.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/support/:id/show',
        name: 'dashboard.support.show',
        component: () => import('@/pages/Dashboard/TicketShow.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/settings',
        name: 'dashboard.settings',
        component: () => import('@/pages/Dashboard/SettingsPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/dashboard/profile',
        name: 'dashboard.profile',
        component: () => import('@/pages/Dashboard/ProfilePage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
]

export default routes